module.exports = "<svg class=\"Cargo-editIcon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.496 17.028\"><path class=\"Cargo-svgFill\" fill=\"#BEBEBE\" d=\"M10.253 3.24l3.535 3.535-8.485 8.485-3.535-3.535zm4.95 2.12l-3.536-3.535.707-.707a2 2 0 0 1 2.828 0l.707.707a2 2 0 0 1 0 2.828l-.71.708zM0 17.028l.354-3.89 3.535 3.537\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/Cargo/pen.svg
// module id = 1989
// module chunks = 0